const locale = {
	BILLBUDDY: "BillBuddy",
	OVERVIEW: "Übersicht",
	WELCOMEBACK: "Willkommen zurück",
};

export default locale;
